import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AlertService, ApiService } from '../../_services';
import { PasswordValidation } from '../../register';
import { AppComponent } from '../../app.component';
import { MemberService } from '../../_services/member.service';

@Component({templateUrl: 'reset-password-confirm.component.html'})
export class ResetPasswordConfirmComponent implements OnInit {

    registerForm: FormGroup;
    loading = false;
    submitted = false;
    verificationId: string;
    currentProductId: number;
    isVerified= false;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private memberService: MemberService,
        private apiService: ApiService,
        private alertService: AlertService) {
            this.route.queryParams.subscribe(params => {
                this.verificationId = params['id']; 
                this.verificationId = this.trimChar(this.verificationId,'-');
                console.log(this.verificationId);
                if(this.verificationId){
                    apiService.verifyResetPasswordAccount(this.verificationId).subscribe(r=>
                        {
                            if(r){
                                alertService.success("Please type your new password");
                                this.isVerified = true;
                            }
                        },err=>{
                            alertService.error("Could not verify your account. Please contact support team.");
                        });
                }
            });
        }

    ngOnInit() {
        this.registerForm = this.formBuilder.group({
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', Validators.required]
        }, {
            validator: PasswordValidation.MatchPassword // your validation method
          });
    }

    trimChar(string: string, charToRemove: string) {
        while(string.charAt(0)==charToRemove) {
            string = string.substring(1);
        }
    
        while(string.charAt(string.length-1)==charToRemove) {
            string = string.substring(0,string.length-1);
        }
    
        return string;
    }

    get f() { return this.registerForm.controls; }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.registerForm.invalid) {
            return;
        }
        console.log(this.registerForm.value);
        
        

        this.loading = true;


        this.apiService.resetPasswordConfirm(this.verificationId, this.registerForm.value)
            .subscribe(
                r => {
                    this.apiService.login(r.username, this.registerForm.value.password,  AppComponent.whitelabel.productId).subscribe(data=>{
                        localStorage.setItem('openIdTokenParams', JSON.stringify(data));
                        this.router.navigateByUrl("/");
                        this.memberService.isLoggedin = true;
                        //document.location.reload();
                    },err=>{
                        this.alertService.error(err.error);
                        this.loading = false;
                    });
                    //auto login
                },
                err => {
                    this.alertService.error(err.error);
                    this.loading = false;
                });
    }
}



// WEBPACK FOOTER //
// ./src/app/login/reset-password-confirm/reset-password-confirm.component.ts